// extracted by mini-css-extract-plugin
export default {"button":"ud4afb","solid":"h4KgKH","wireframe":"kIflK4","logout":"bA6VfH","text":"mCO84u","textWithIcon":"hRcYa1","login":"vy8kVx"};